import Fuse from 'fuse.js';
const defaultOptions = {
  minMatchCharLength: 3,
  includeScore: true,
  threshold: 0.25
};
export default class SearchService {
  constructor(data, options) {
    this.fuseInstance = new Fuse(data, {
      ...defaultOptions,
      ...options
    });
  }
  search(searchTerm) {
    const result = this.fuseInstance.search(searchTerm);
    const res = result.map(i => i.item);

    // If no results
    if (searchTerm.length >= defaultOptions.minMatchCharLength && !res.length) {
      return undefined;
    }
    if (res.length) {
      return res;
    }
    return [...this.fuseInstance.list];
  }
}